import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { rangeMax, rangeMin } from './static-props'
import { ariaLabel } from '../../utils/form-utilities'

export const HoursUsedMin = withFacetContext(
    FacetName.hours_used,
    withFilterContext(FilterName.min_hours_used, SearchFiltersDropdown, {
        ...rangeMin,
        ariaLabel: ariaLabel.hours.min,
    })
)

export const HoursUsedMax = withFacetContext(
    FacetName.hours_used,
    withFilterContext(FilterName.max_hours_used, SearchFiltersDropdown, {
        ...rangeMax,
        ariaLabel: ariaLabel.hours.max,
    })
)
